import { NotificationIcon, OutlineArchive } from '@assets/icons'
import ArrowUp from './ArrowUp'
import LogoDefault from './LogoDefault'
import LogoFull from './LogoFull'
import TeacherLogoFull from '@components/layout/ExpandIcon/TeacherLogoFull'
import {
  AddNote,
  BookMark,
  Calculator,
  CourseContent,
  NoteList,
  Union,
} from '@components/courses/icons'

type ExpandIconPros = {
  isExpanded?: boolean
  handleClick?: () => void | undefined
  type: string
  className?: string
}

export default function ExpandIcon({
  isExpanded,
  handleClick,
  type,
  className,
}: ExpandIconPros) {
  return (
    <>
      {isExpanded && type === 'ontoggle' ? (
        <div onClick={handleClick}>
          <ArrowUp className={`${className}`} />
        </div>
      ) : (
        type === 'ontoggle' && (
          <div onClick={handleClick}>
            <ArrowUp className={`rotate-180 ${className}`} />
          </div>
        )
      )}
      {type === 'logo-default' && <LogoDefault />}
      {type === 'logo-full' && <LogoFull />}
      {type === 'teacher-logo-full' && <TeacherLogoFull />}
      {type === 'stats-chart-sharp' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M6 23.25H2.25v-9H6v9zM16.5 23.25h-3.75V9.75h3.75v13.5zM21.75 23.25H18V4.5h3.75v18.75zM11.25 23.25H7.5V.75h3.75v22.5z"
          ></path>
        </svg>
      )}
      {type === 'course' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M12.75 1.954v6.858a.188.188 0 00.188.188h6.858a.094.094 0 00.066-.16L12.91 1.888a.093.093 0 00-.16.066z"
          ></path>
          <path
            fill="currentColor"
            d="M11.625 10.5a.375.375 0 01-.375-.375V1.5H4.312a.563.563 0 00-.562.563v19.875a.562.562 0 00.563.562h15.375a.562.562 0 00.562-.563V10.5h-8.625zM16.5 18h-9v-1.5h9V18zm0-3.75h-9v-1.5h9v1.5z"
          ></path>
        </svg>
      )}
      {type === 'result' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="m21 2.25-1.5-.75-1.5.75-1.5-.75-1.5.75-1.5-.75-1.5.75-1.5-.75-1.5.75-2.25-.75v12.002h10.5v6.373c0 1.45 1.55 2.625 3 2.625h.563c1.45 0 2.437-1.175 2.437-2.625V1.5L21 2.25Zm-8.227 9-.023-1.5h7.477l.023 1.5h-7.477Zm-3-3.75L9.75 6h10.477l.023 1.5H9.773Z"
          />
          <path
            fill="currentColor"
            d="M15.75 19.875V15h-15v1.5c0 2.37.27 3.357.678 4.108.69 1.273 1.94 1.892 3.822 1.892h12s-1.5-.938-1.5-2.625Z"
          />
        </svg>
      )}

      {type === 'caculator' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M19.5 2.25a.75.75 0 00-.75-.75H5.25a.75.75 0 00-.75.75v19.5a.75.75 0 00.75.75h13.5a.75.75 0 00.75-.75V2.25zM9 20.25H6.75V18H9v2.25zm0-3.75H6.75v-2.25H9v2.25zm0-3.75H6.75V10.5H9v2.25zm4.125 7.5h-2.25V18h2.25v2.25zm0-3.75h-2.25v-2.25h2.25v2.25zm0-3.75h-2.25V10.5h2.25v2.25zm4.125 7.5H15v-6h2.25v6zm0-7.5H15V10.5h2.25v2.25zm0-4.5H6.75v-4.5h10.5v4.5z"
          ></path>
        </svg>
      )}
      {type === 'document' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.344.889h9.313C20.089.889 22 2.866 22 6.255v11.478c0 3.445-1.911 5.378-5.343 5.378H7.344C3.967 23.11 2 21.178 2 17.733V6.255C2 2.866 3.967.89 7.344.89zm.3 5.178v-.01h3.322c.479 0 .867.388.867.865a.87.87 0 01-.867.879H7.644a.867.867 0 010-1.734zm0 6.756h8.712a.868.868 0 000-1.734H7.644a.868.868 0 000 1.734zm0 5.078h8.712a.87.87 0 00.777-.867.872.872 0 00-.777-.878H7.644a.883.883 0 00-.833 1.344c.178.279.5.445.833.4z"
            clipRule="evenodd"
          ></path>
        </svg>
      )}
      {type === 'grid' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M9.563 11.25H3.186A1.687 1.687 0 011.5 9.562V3.189A1.687 1.687 0 013.188 1.5h6.374a1.687 1.687 0 011.688 1.688v6.374a1.687 1.687 0 01-1.688 1.688zM20.813 11.25h-6.375a1.687 1.687 0 01-1.688-1.688V3.189A1.687 1.687 0 0114.438 1.5h6.374A1.687 1.687 0 0122.5 3.188v6.374a1.687 1.687 0 01-1.688 1.688zM9.563 22.5H3.186A1.687 1.687 0 011.5 20.812v-6.375a1.687 1.687 0 011.688-1.687h6.374a1.687 1.687 0 011.688 1.688v6.374A1.687 1.687 0 019.562 22.5zM20.813 22.5h-6.375a1.687 1.687 0 01-1.688-1.688v-6.375a1.687 1.687 0 011.688-1.687h6.374a1.687 1.687 0 011.688 1.688v6.374a1.687 1.687 0 01-1.688 1.688z"
          ></path>
        </svg>
      )}

      {type === 'forder' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="44"
          fill="none"
          viewBox="0 0 44 44"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M25 23.56a.77.77 0 01-.77.76h-1.65v1.65a.761.761 0 01-.74.79.76.76 0 01-.76-.74L21 24.29h-1.71a.77.77 0 01-.76-.77.78.78 0 01.78-.76h1.65v-1.65a.77.77 0 01.74-.79.74.74 0 01.79.75v1.7h1.72a.77.77 0 01.79.79zm7.07-4.82a6.78 6.78 0 00-6.61-6.43h-4.93a2.759 2.759 0 00-2.17-1.06h-2.15a4.92 4.92 0 00-4.91 4.93v10.89a5.66 5.66 0 005.7 5.68h10.1a5.66 5.66 0 005.65-5.68v-5.72a5.719 5.719 0 00-.69-2.61h.01zm-2.33-2.38a5.57 5.57 0 00-2.69-.69h-3.17a2.77 2.77 0 01-2.58-1.76v-.07h4.18a5 5 0 014.26 2.52zm1.43 10.71a4.14 4.14 0 01-4.12 4.15H17a4.14 4.14 0 01-4.12-4.15V16.18a3.39 3.39 0 013.38-3.4h2.1a1.26 1.26 0 011.17.8l.36.9a4.26 4.26 0 004 2.72h3.17a4.14 4.14 0 014.12 4.15l-.01 5.72z"
          ></path>
        </svg>
      )}
      {type === 'home' && (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <rect width="44" height="44" rx="9" fill="currentColor" />
          <path
            d="M16.3598 32.57C15.3231 32.5697 14.3226 32.1886 13.5483 31.4991C12.774 30.8096 12.2799 29.8598 12.1598 28.83L11.2798 21.32C11.1982 20.5958 11.3032 19.8627 11.585 19.1905C11.8669 18.5183 12.316 17.9295 12.8898 17.48L19.5898 12.31C20.355 11.7251 21.2962 11.4175 22.2591 11.4374C23.222 11.4574 24.1496 11.8039 24.8898 12.42L31.2398 17.77C31.8043 18.2431 32.2352 18.8557 32.4896 19.5469C32.7439 20.2381 32.813 20.9839 32.6898 21.71L31.4398 29C31.2744 29.9838 30.7657 30.8772 30.0042 31.5215C29.2426 32.1659 28.2774 32.5197 27.2798 32.52H16.3698L16.3598 32.57ZM22.1698 12.94C21.5663 12.9356 20.9786 13.1326 20.4998 13.5L13.8098 18.67C13.4467 18.9626 13.1643 19.3431 12.9893 19.7753C12.8143 20.2075 12.7526 20.6773 12.8098 21.14L13.6898 28.66C13.7682 29.3239 14.0873 29.9359 14.5868 30.3801C15.0863 30.8242 15.7314 31.0698 16.3998 31.07H27.3098C27.9574 31.071 28.5841 30.841 29.0772 30.4212C29.5703 30.0014 29.8975 29.4195 29.9998 28.78L31.2498 21.46C31.3296 20.9908 31.2858 20.5089 31.1228 20.0618C30.9597 19.6147 30.683 19.2177 30.3198 18.91L23.9298 13.57C23.4347 13.161 22.8121 12.9381 22.1698 12.94ZM21.9998 26.41C21.3428 26.41 20.7005 26.2151 20.1543 25.8498C19.6081 25.4846 19.1826 24.9655 18.9316 24.3582C18.6806 23.751 18.6155 23.0829 18.7444 22.4387C18.8733 21.7944 19.1905 21.2028 19.6558 20.7389C20.1211 20.275 20.7136 19.9596 21.3583 19.8326C22.003 19.7057 22.6708 19.7728 23.2773 20.0256C23.8838 20.2785 24.4016 20.7056 24.7652 21.2528C25.1288 21.8001 25.3218 22.443 25.3198 23.1C25.3172 23.9788 24.9662 24.8207 24.3439 25.4412C23.7216 26.0616 22.8786 26.41 21.9998 26.41ZM21.9998 21.28C21.6399 21.28 21.288 21.3868 20.9887 21.5868C20.6894 21.7868 20.4561 22.071 20.3184 22.4036C20.1806 22.7361 20.1446 23.1021 20.2148 23.4551C20.285 23.8082 20.4584 24.1324 20.7129 24.387C20.9674 24.6415 21.2917 24.8148 21.6448 24.8851C21.9978 24.9553 22.3637 24.9193 22.6963 24.7815C23.0289 24.6438 23.3131 24.4105 23.5131 24.1112C23.7131 23.8119 23.8198 23.46 23.8198 23.1C23.8198 22.861 23.7727 22.6244 23.6813 22.4036C23.5898 22.1827 23.4558 21.9821 23.2868 21.8131C23.1178 21.6441 22.9171 21.51 22.6963 21.4186C22.4755 21.3271 22.2388 21.28 21.9998 21.28Z"
            fill="#FFB800"
          />
        </svg>
      )}
      {type === 'logout' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="44"
          fill="none"
          viewBox="0 0 44 44"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M21.33 32.75h-4.44a4.81 4.81 0 01-4.95-4.64V15.89a4.81 4.81 0 014.95-4.64h4.44a4.8 4.8 0 014.94 4.64.76.76 0 11-1.52 0 3.29 3.29 0 00-3.42-3.12h-4.44a3.28 3.28 0 00-3.42 3.12v12.22a3.28 3.28 0 003.42 3.12h4.44a3.29 3.29 0 003.42-3.12.76.76 0 011.52 0 4.8 4.8 0 01-4.94 4.64zM17.88 22a.76.76 0 00.76.76h10.07L27 24.43a.76.76 0 001.07 1.08l3-3a.76.76 0 000-1.08l-3-3a.748.748 0 00-1.07 0 .76.76 0 000 1.08l1.67 1.67H18.64a.76.76 0 00-.76.82z"
          ></path>
        </svg>
      )}

      {type === 'notification' && <NotificationIcon className={className} />}
      {type === 'setting' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="24"
          fill="none"
          viewBox="0 0 22 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M21.031 14.111a2.443 2.443 0 01-1.221-2.11c0-.87.468-1.678 1.22-2.111a1.757 1.757 0 00.761-2.19 11.554 11.554 0 00-1.667-2.896 1.759 1.759 0 00-2.28-.436 2.443 2.443 0 01-2.44.003 2.44 2.44 0 01-1.216-2.115A1.76 1.76 0 0012.67.5a11.593 11.593 0 00-3.343.003 1.757 1.757 0 00-1.514 1.755c0 .87-.465 1.679-1.217 2.113a2.445 2.445 0 01-2.44-.003 1.76 1.76 0 00-2.28.438 11.718 11.718 0 00-1.668 2.89 1.758 1.758 0 00.76 2.193A2.442 2.442 0 012.19 12c0 .868-.468 1.677-1.22 2.11a1.756 1.756 0 00-.762 2.19 11.535 11.535 0 001.667 2.896c.552.7 1.51.882 2.28.436a2.444 2.444 0 012.441-.003 2.448 2.448 0 011.217 2.115A1.759 1.759 0 009.33 23.5a11.587 11.587 0 003.343-.003 1.76 1.76 0 001.516-1.755 2.439 2.439 0 011.215-2.113 2.445 2.445 0 012.44.003 1.759 1.759 0 002.28-.438c.344-.436.66-.902.939-1.385.277-.483.525-.99.73-1.504a1.757 1.757 0 00-.76-2.194zm-7.042-.385a3.42 3.42 0 01-2.096 1.608 3.426 3.426 0 01-2.619-.345 3.456 3.456 0 01-1.263-4.715 3.452 3.452 0 014.714-1.263 3.457 3.457 0 011.264 4.715z"
            clipRule="evenodd"
          ></path>
        </svg>
      )}
      {type === 'avatar' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          viewBox="0 0 512 512"
          width="40"
          height="40"
          className={`!h-10 !w-10 ${className}`}
        >
          <path
            fill="currentColor"
            d="M1 512c7.14-71.46 51.4-135.92 119.86-174 52.86 56.46 120.76 101.67 123.82 103.7l11.3 7.49 11.29-7.49c3.07-2 71-47.24 123.83-103.7 68.48 38.08 112.75 102.54 119.9 174zm255-232c-86.76 0-157.36-62.8-157.36-140S169.24 0 256 0s157.36 62.81 157.36 140S342.77 280 256 280z"
          ></path>
        </svg>
      )}
      {type === 'dot' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="4"
          height="4"
          version="1.1"
          viewBox="0 0 31.955 31.955"
          xmlSpace="preserve"
          className={`!min-h-[4px] !min-w-[4px] ${className}`}
        >
          <g fill="#181C32">
            <path d="M27.25 4.655c-6.254-6.226-16.37-6.201-22.594.051-6.227 6.254-6.204 16.37.049 22.594 6.256 6.226 16.374 6.203 22.597-.051 6.224-6.254 6.203-16.371-.052-22.594z"></path>
            <path d="M13.288 23.896l-1.768 5.207c2.567.829 5.331.886 7.926.17l-.665-5.416a8.382 8.382 0 01-5.493.039zM8.12 13.122l-5.645-.859a13.856 13.856 0 00.225 8.143l5.491-1.375a8.391 8.391 0 01-.071-5.909zm20.643-1.789l-4.965 1.675a8.39 8.39 0 01-.247 6.522l5.351.672a13.868 13.868 0 00-.139-8.869zm-17.369-8.45l1.018 5.528a8.395 8.395 0 016.442-.288l1.583-5.137a13.855 13.855 0 00-9.043-.103z"></path>
            <circle cx="15.979" cy="15.977" r="6.117"></circle>
          </g>
        </svg>
      )}
      {type === 'learning-resource' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`!min-h-[4px] !min-w-[4px] ${className}`}
        >
          <path
            fill="currentColor"
            d="M21.938 2.25H2.063a.563.563 0 00-.563.563v2.624c0 .311.252.563.563.563h19.875c.31 0 .562-.252.562-.563V2.813a.562.562 0 00-.563-.562zM3 7.5v13.125a1.125 1.125 0 001.125 1.125h15.75A1.125 1.125 0 0021 20.625V7.5H3zm9 10.81l-4.063-4.06L9 13.187l2.25 2.252V9.75h1.5v5.69l2.253-2.254 1.06 1.061L12 18.311z"
          ></path>
        </svg>
      )}
      {type === 'entrance-test' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`!min-h-[4px] !min-w-[4px] ${className}`}
        >
          <path
            d="M7.5 11.25H14.408L11.408 8.25L12.4688 7.18922L17.2795 12L12.4688 16.8108L11.408 15.75L14.408 12.75H7.5V19.6875C7.5 19.8367 7.55926 19.9798 7.66475 20.0852C7.77024 20.1907 7.91332 20.25 8.0625 20.25H21.9375C22.0867 20.25 22.2298 20.1907 22.3352 20.0852C22.4407 19.9798 22.5 19.8367 22.5 19.6875V4.3125C22.5 4.16332 22.4407 4.02024 22.3352 3.91475C22.2298 3.80926 22.0867 3.75 21.9375 3.75H8.0625C7.91332 3.75 7.77024 3.80926 7.66475 3.91475C7.55926 4.02024 7.5 4.16332 7.5 4.3125V11.25Z"
            fill="currentColor"
            className="group-resource"
          />
          <path
            d="M7.5 11.25H1.5V12.75H7.5V11.25Z"
            fill="currentColor"
            className="group-resource"
          />
        </svg>
      )}

      {type === 'event-test' && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`!min-h-[4px] !min-w-[4px] ${className}`}
        >
          <path
            d="M3.75 1.5L0.75 7.5H14.302L18.0623 1.5H3.75Z"
            fill="currentColor"
            className="group-resource"
          />
          <path
            className="group-resource"
            d="M23.2501 6.75L19.8751 1.5L13.9689 10.8319C12.6938 10.3889 11.3065 10.3889 10.0314 10.8319L8.88436 9H2.0542L6.11639 15.323C5.94174 16.1936 5.96253 17.0922 6.17725 17.9538C6.39197 18.8155 6.79528 19.6187 7.35806 20.3056C7.92085 20.9925 8.62909 21.5459 9.43168 21.9259C10.2343 22.3059 11.1112 22.503 11.9992 22.503C12.8872 22.503 13.7641 22.3059 14.5667 21.9259C15.3693 21.5459 16.0775 20.9925 16.6403 20.3056C17.2031 19.6187 17.6064 18.8155 17.8212 17.9538C18.0359 17.0922 18.0567 16.1936 17.882 15.323L23.2501 6.75ZM12.0001 19.7812C11.3512 19.7812 10.7168 19.5888 10.1772 19.2283C9.63757 18.8677 9.21701 18.3552 8.96866 17.7557C8.72031 17.1561 8.65533 16.4964 8.78194 15.8599C8.90854 15.2234 9.22105 14.6387 9.67994 14.1798C10.1388 13.7209 10.7235 13.4084 11.36 13.2818C11.9965 13.1552 12.6562 13.2202 13.2558 13.4685C13.8554 13.7169 14.3678 14.1374 14.7284 14.677C15.0889 15.2166 15.2814 15.851 15.2814 16.5C15.2804 17.3699 14.9344 18.204 14.3192 18.8191C13.7041 19.4342 12.8701 19.7803 12.0001 19.7812Z"
            fill="currentColor"
          />
          <path
            className="group-resource"
            d="M12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z"
            fill="currentColor"
          />
        </svg>
      )}

      {type === 'notes-list' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M14.435 11.625l-4.31-4.382v4.1a.281.281 0 00.281.282h4.029z"
          ></path>
          <path
            fill="currentColor"
            d="M8.625 12.563V6.75H2.812a.563.563 0 00-.562.563v15.375a.562.562 0 00.563.562h11.624a.562.562 0 00.563-.563v-9.562H9.187a.563.563 0 01-.562-.563zM17.156 5.625h4.029l-4.31-4.382v4.1a.281.281 0 00.281.282z"
          ></path>
          <path
            fill="currentColor"
            d="M15.938 7.125a.562.562 0 01-.563-.563V.75H8.062a.563.563 0 00-.562.563V5.25h1.974a1.913 1.913 0 011.354.57l5.117 5.202c.357.362.556.851.555 1.36v6.368h4.688a.562.562 0 00.562-.563V7.126h-5.813z"
          ></path>
        </svg>
      )}
      {type === 'create-note' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M21.767 2.306a1.034 1.034 0 00-1.494-.035l-.858.855 1.461 1.458.844-.84a1.04 1.04 0 00.047-1.438zM11.848 15.75H8.25v-3.598l.44-.44 6.476-6.462H2.25v16.5h16.5V8.834l-6.462 6.475-.44.441zM18.75 6.71l1.537-1.54-1.457-1.457-1.54 1.537h1.46v1.46z"
          ></path>
          <path
            fill="currentColor"
            d="M9.75 14.25h1.476l7.524-7.54V5.25h-1.46l-7.54 7.524v1.476z"
          ></path>
        </svg>
      )}
      {type === 'profile-detail' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.544 15.73H10.97a.134.134 0 01-.133-.135v-1.573a.134.134 0 01.133-.133h1.574a.134.134 0 01.133.133v1.573a.134.134 0 01-.133.134zm.885-5.157c-.844.567-.96 1.086-.96 1.562v.573a.156.156 0 01-.156.157h-1.146a.156.156 0 01-.157-.157v-.573c0-1.14.525-2.048 1.606-2.774 1.004-.674 1.572-1.1 1.572-2.04 0-.638-.365-1.123-1.12-1.482-.177-.084-.573-.167-1.06-.16-.61.007-1.083.153-1.449.447-.688.554-.746 1.157-.746 1.166a3.422 3.422 0 00-.044.535.156.156 0 01-.156.156H8.506a.156.156 0 01-.157-.14 3.213 3.213 0 01.005-.625c.012-.126.094-1.266 1.29-2.229.62-.499 1.41-.758 2.344-.77.662-.008 1.283.104 1.704.303 1.261.6 1.954 1.594 1.954 2.8 0 1.761-1.178 2.553-2.217 3.25z"
          ></path>
        </svg>
      )}
      {type === 'exam_information' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          className={`${className}`}
        >
          <path
            fill="currentColor"
            d="M2 2v20a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1Zm9 13H5v-2h6v2Zm5-4H5V9h11v2Zm0-4H5V5h11v2Z"
          />
        </svg>
      )}
      {type === 'bookmark' && (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.27103 2.11151C5.46135 2.21816 5.03258 2.41324 4.72718 2.71244C4.42179 3.01165 4.22268 3.43172 4.11382 4.225C4.00176 5.04159 4 6.12387 4 7.67568V16.2442C4.38867 15.9781 4.82674 15.7756 5.29899 15.6517C5.82716 15.513 6.44305 15.5132 7.34563 15.5135L20 15.5135V7.67568C20 6.12387 19.9982 5.04159 19.8862 4.22499C19.7773 3.43172 19.5782 3.01165 19.2728 2.71244C18.9674 2.41324 18.5387 2.21816 17.729 2.11151C16.8955 2.00172 15.7908 2 14.2069 2H9.7931C8.2092 2 7.10452 2.00172 6.27103 2.11151ZM6.75862 6.59459C6.75862 6.1468 7.12914 5.78378 7.58621 5.78378H16.4138C16.8709 5.78378 17.2414 6.1468 17.2414 6.59459C17.2414 7.04239 16.8709 7.40541 16.4138 7.40541H7.58621C7.12914 7.40541 6.75862 7.04239 6.75862 6.59459ZM7.58621 9.56757C7.12914 9.56757 6.75862 9.93058 6.75862 10.3784C6.75862 10.8262 7.12914 11.1892 7.58621 11.1892H13.1034C13.5605 11.1892 13.931 10.8262 13.931 10.3784C13.931 9.93058 13.5605 9.56757 13.1034 9.56757H7.58621Z"
              fill="currentColor"
            ></path>
            <path
              d="M7.47341 17.1351H8.68965H13.1034H19.9991C19.9956 18.2657 19.9776 19.1088 19.8862 19.775C19.7773 20.5683 19.5782 20.9884 19.2728 21.2876C18.9674 21.5868 18.5387 21.7818 17.729 21.8885C16.8955 21.9983 15.7908 22 14.2069 22H9.7931C8.2092 22 7.10452 21.9983 6.27103 21.8885C5.46135 21.7818 5.03258 21.5868 4.72718 21.2876C4.42179 20.9884 4.22268 20.5683 4.11382 19.775C4.07259 19.4746 4.0463 19.1382 4.02952 18.7558C4.30088 18.0044 4.93365 17.4264 5.72738 17.218C6.01657 17.1421 6.39395 17.1351 7.47341 17.1351Z"
              fill="currentColor"
            ></path>
          </g>
        </svg>
      )}
      {type === 'calendar' && (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${className}`}
        >
          <path
            d="M1.5 21.8936C1.5 22.1919 1.61853 22.4781 1.8295 22.689C2.04048 22.9 2.32663 23.0186 2.625 23.0186H21.375C21.6734 23.0186 21.9595 22.9 22.1705 22.689C22.3815 22.4781 22.5 22.1919 22.5 21.8936V8.76855H1.5V21.8936ZM16.5 10.4561C16.5 10.4063 16.5198 10.3586 16.5549 10.3235C16.5901 10.2883 16.6378 10.2686 16.6875 10.2686H18.5625C18.6122 10.2686 18.6599 10.2883 18.6951 10.3235C18.7302 10.3586 18.75 10.4063 18.75 10.4561V12.3311C18.75 12.3808 18.7302 12.4285 18.6951 12.4636C18.6599 12.4988 18.6122 12.5186 18.5625 12.5186H16.6875C16.6378 12.5186 16.5901 12.4988 16.5549 12.4636C16.5198 12.4285 16.5 12.3808 16.5 12.3311V10.4561ZM16.5 14.2061C16.5 14.1563 16.5198 14.1086 16.5549 14.0735C16.5901 14.0383 16.6378 14.0186 16.6875 14.0186H18.5625C18.6122 14.0186 18.6599 14.0383 18.6951 14.0735C18.7302 14.1086 18.75 14.1563 18.75 14.2061V16.0811C18.75 16.1308 18.7302 16.1785 18.6951 16.2136C18.6599 16.2488 18.6122 16.2686 18.5625 16.2686H16.6875C16.6378 16.2686 16.5901 16.2488 16.5549 16.2136C16.5198 16.1785 16.5 16.1308 16.5 16.0811V14.2061ZM12.75 10.4561C12.75 10.4063 12.7698 10.3586 12.8049 10.3235C12.8401 10.2883 12.8878 10.2686 12.9375 10.2686H14.8125C14.8622 10.2686 14.9099 10.2883 14.9451 10.3235C14.9802 10.3586 15 10.4063 15 10.4561V12.3311C15 12.3808 14.9802 12.4285 14.9451 12.4636C14.9099 12.4988 14.8622 12.5186 14.8125 12.5186H12.9375C12.8878 12.5186 12.8401 12.4988 12.8049 12.4636C12.7698 12.4285 12.75 12.3808 12.75 12.3311V10.4561ZM12.75 14.2061C12.75 14.1563 12.7698 14.1086 12.8049 14.0735C12.8401 14.0383 12.8878 14.0186 12.9375 14.0186H14.8125C14.8622 14.0186 14.9099 14.0383 14.9451 14.0735C14.9802 14.1086 15 14.1563 15 14.2061V16.0811C15 16.1308 14.9802 16.1785 14.9451 16.2136C14.9099 16.2488 14.8622 16.2686 14.8125 16.2686H12.9375C12.8878 16.2686 12.8401 16.2488 12.8049 16.2136C12.7698 16.1785 12.75 16.1308 12.75 16.0811V14.2061ZM12.75 17.9561C12.75 17.9063 12.7698 17.8586 12.8049 17.8235C12.8401 17.7883 12.8878 17.7686 12.9375 17.7686H14.8125C14.8622 17.7686 14.9099 17.7883 14.9451 17.8235C14.9802 17.8586 15 17.9063 15 17.9561V19.8311C15 19.8808 14.9802 19.9285 14.9451 19.9636C14.9099 19.9988 14.8622 20.0186 14.8125 20.0186H12.9375C12.8878 20.0186 12.8401 19.9988 12.8049 19.9636C12.7698 19.9285 12.75 19.8808 12.75 19.8311V17.9561ZM9 14.2061C9 14.1563 9.01975 14.1086 9.05492 14.0735C9.09008 14.0383 9.13777 14.0186 9.1875 14.0186H11.0625C11.1122 14.0186 11.1599 14.0383 11.1951 14.0735C11.2302 14.1086 11.25 14.1563 11.25 14.2061V16.0811C11.25 16.1308 11.2302 16.1785 11.1951 16.2136C11.1599 16.2488 11.1122 16.2686 11.0625 16.2686H9.1875C9.13777 16.2686 9.09008 16.2488 9.05492 16.2136C9.01975 16.1785 9 16.1308 9 16.0811V14.2061ZM9 17.9561C9 17.9063 9.01975 17.8586 9.05492 17.8235C9.09008 17.7883 9.13777 17.7686 9.1875 17.7686H11.0625C11.1122 17.7686 11.1599 17.7883 11.1951 17.8235C11.2302 17.8586 11.25 17.9063 11.25 17.9561V19.8311C11.25 19.8808 11.2302 19.9285 11.1951 19.9636C11.1599 19.9988 11.1122 20.0186 11.0625 20.0186H9.1875C9.13777 20.0186 9.09008 19.9988 9.05492 19.9636C9.01975 19.9285 9 19.8808 9 19.8311V17.9561ZM5.25 14.2061C5.25 14.1563 5.26975 14.1086 5.30492 14.0735C5.34008 14.0383 5.38777 14.0186 5.4375 14.0186H7.3125C7.36223 14.0186 7.40992 14.0383 7.44508 14.0735C7.48025 14.1086 7.5 14.1563 7.5 14.2061V16.0811C7.5 16.1308 7.48025 16.1785 7.44508 16.2136C7.40992 16.2488 7.36223 16.2686 7.3125 16.2686H5.4375C5.38777 16.2686 5.34008 16.2488 5.30492 16.2136C5.26975 16.1785 5.25 16.1308 5.25 16.0811V14.2061ZM5.25 17.9561C5.25 17.9063 5.26975 17.8586 5.30492 17.8235C5.34008 17.7883 5.38777 17.7686 5.4375 17.7686H7.3125C7.36223 17.7686 7.40992 17.7883 7.44508 17.8235C7.48025 17.8586 7.5 17.9063 7.5 17.9561V19.8311C7.5 19.8808 7.48025 19.9285 7.44508 19.9636C7.40992 19.9988 7.36223 20.0186 7.3125 20.0186H5.4375C5.38777 20.0186 5.34008 19.9988 5.30492 19.9636C5.26975 19.9285 5.25 19.8808 5.25 19.8311V17.9561Z"
            fill="currentColor"
          />
          <path
            d="M21.375 3.51855H18.7537V2.01855H16.5037V3.51855H7.49625V2.01855H5.24625V3.51855H2.625C2.47783 3.51732 2.33186 3.54521 2.19551 3.60064C2.05917 3.65606 1.93514 3.73792 1.83057 3.84149C1.72599 3.94505 1.64295 4.06829 1.58622 4.2041C1.52948 4.3399 1.50018 4.48559 1.5 4.63277V7.26855H22.5V4.63277C22.4998 4.48559 22.4705 4.3399 22.4138 4.2041C22.357 4.06829 22.274 3.94505 22.1694 3.84149C22.0649 3.73792 21.9408 3.65606 21.8045 3.60064C21.6681 3.54521 21.5222 3.51732 21.375 3.51855Z"
            fill="currentColor"
          />
        </svg>
      )}
      {type === 'outline-archive' && <OutlineArchive className={className} />}
      {type === 'union' && <Union className={className} />}
      {type === 'book-mark' && <BookMark className={className} />}
      {type === 'course-content' && <CourseContent className={className} />}
      {type === 'note-list' && <NoteList className={className} />}
      {type === 'calculator' && <Calculator className={className} />}
      {type === 'add-note' && <AddNote className={className} />}
    </>
  )
}
